<script setup lang="ts">
import { cartBus } from '@/event/cartBus'
import {
  deleteElementBasketBus,
  elementBasketBus,
  indexDeleteElement
} from '@/event/deleteElementBasketBus'

const toggleBasketDelete = () => {
  deleteElementBasketBus.value = !deleteElementBasketBus.value
}

const validateDeleteBasket = () => {
  if (indexDeleteElement.value >= 0 && indexDeleteElement.value < cartBus.value.length) {
    cartBus.value.splice(indexDeleteElement.value, 1)
  }
  toggleBasketDelete()
}
</script>

<template>
  <div class="relative w-full flex justify-center" v-if="deleteElementBasketBus">
    <div @click="toggleBasketDelete" class="basket-delete-overlay"></div>
    <div v-if="deleteElementBasketBus && elementBasketBus" class="basket-delete">
      <p>Voulez-vous supprimer :</p>
      <p class="font-semibold uppercase underline">{{ elementBasketBus.product }}</p>
      <p>de votre panier ?</p>
      <div class="div-button-delete">
        <button class="button-delete" @click="toggleBasketDelete">
          <svg class="svg-cross" viewBox="0 0 30 30" fill="" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_688_4815)">
              <path
                d="M0 27.2719L2.72813 30L15 17.7281L27.2719 30L30 27.2719L17.7281 15L30 2.72813L27.2719 0L15 12.2719L2.72813 0L0 2.72813L12.2719 15L0 27.2719Z"
                fill="" />
            </g>
            <defs>
              <clipPath id="clip0_688_4815">
                <rect width="30" height="30" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
        <button class="button-validate" @click="validateDeleteBasket">
          <svg class="svg-validate" viewBox="0 0 42 34" fill="" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1 15.6084L12.1307 33C12.1307 33 35.7833 2.39146 41.3486 1C34.392 1.69579 12.8263 25.3477 12.8263 25.3477L3.78266 10.043L1 15.6084Z"
              fill="" />
            <path
              d="M1 15.6084L0.552786 15.3848L0.425801 15.6387L0.578864 15.8779L1 15.6084ZM12.1307 33L11.7095 33.2695L12.0922 33.8675L12.5263 33.3057L12.1307 33ZM41.3486 1L41.4699 1.48507C41.7241 1.4215 41.8861 1.17243 41.8412 0.914254C41.7963 0.656077 41.5596 0.476402 41.2989 0.502482L41.3486 1ZM3.78266 10.043L4.21313 9.78867L3.74605 8.99823L3.33545 9.81943L3.78266 10.043ZM12.8263 25.3477L12.3959 25.602L12.74 26.1844L13.1958 25.6846L12.8263 25.3477ZM0.578864 15.8779L11.7095 33.2695L12.5518 32.7305L1.42114 15.3388L0.578864 15.8779ZM12.1307 33C12.5263 33.3057 12.5264 33.3056 12.5265 33.3054C12.5267 33.3052 12.527 33.3049 12.5273 33.3044C12.528 33.3035 12.5291 33.3021 12.5305 33.3003C12.5333 33.2966 12.5376 33.2911 12.5432 33.2838C12.5545 33.2692 12.5715 33.2473 12.5939 33.2185C12.6386 33.1607 12.7052 33.0749 12.7923 32.9628C12.9666 32.7387 13.2231 32.4097 13.5515 31.9904C14.2084 31.1516 15.1531 29.9517 16.3043 28.5073C18.607 25.6182 21.7343 21.7526 25.0346 17.8444C28.3363 13.9346 31.8054 9.98898 34.7928 6.93676C36.2871 5.41001 37.6534 4.11449 38.8129 3.16065C39.9948 2.18851 40.8954 1.62871 41.4699 1.48507L41.2273 0.514931C40.4105 0.719156 39.3546 1.42025 38.1777 2.38835C36.9785 3.37475 35.5839 4.69881 34.0781 6.23729C31.0653 9.31551 27.5778 13.2829 24.2706 17.1992C20.9622 21.117 17.8285 24.9905 15.5223 27.884C14.3691 29.3309 13.4226 30.5332 12.7642 31.3738C12.435 31.7941 12.1779 32.124 12.0029 32.349C11.9155 32.4615 11.8486 32.5477 11.8035 32.6058C11.7809 32.6349 11.7639 32.657 11.7524 32.6718C11.7467 32.6792 11.7423 32.6848 11.7394 32.6886C11.738 32.6904 11.7369 32.6918 11.7361 32.6928C11.7358 32.6933 11.7355 32.6936 11.7353 32.6939C11.7351 32.6941 11.735 32.6943 12.1307 33ZM1.44721 15.832L4.22988 10.2666L3.33545 9.81943L0.552786 15.3848L1.44721 15.832ZM3.3522 10.2974L12.3959 25.602L13.2568 25.0933L4.21313 9.78867L3.3522 10.2974ZM12.8263 25.3477C13.1958 25.6846 13.1958 25.6845 13.196 25.6843C13.1961 25.6842 13.1964 25.6839 13.1967 25.6836C13.1973 25.6829 13.1983 25.6819 13.1995 25.6805C13.2021 25.6777 13.2059 25.6735 13.2111 25.6678C13.2213 25.6566 13.2367 25.6398 13.2571 25.6176C13.2978 25.5731 13.3585 25.5069 13.438 25.4206C13.5971 25.2478 13.8316 24.994 14.1325 24.6707C14.7345 24.024 15.6025 23.099 16.666 21.9867C18.7934 19.7618 21.7011 16.7891 24.8247 13.7958C27.95 10.8007 31.2832 7.79303 34.2626 5.4937C35.7527 4.34375 37.1453 3.37807 38.3727 2.68069C39.6119 1.97661 40.6355 1.57382 41.3984 1.49752L41.2989 0.502482C40.3226 0.600126 39.1504 1.08867 37.8787 1.81123C36.5952 2.54049 35.1616 3.53676 33.6517 4.70203C30.6311 7.03311 27.2684 10.0688 24.1328 13.0738C20.9953 16.0804 18.0769 19.0642 15.9433 21.2957C14.8763 22.4116 14.0051 23.3399 13.4006 23.9894C13.0983 24.3141 12.8626 24.5692 12.7024 24.7432C12.6223 24.8302 12.561 24.897 12.5197 24.9421C12.4991 24.9646 12.4834 24.9817 12.4729 24.9932C12.4676 24.999 12.4637 25.0033 12.461 25.0063C12.4596 25.0077 12.4586 25.0089 12.4579 25.0096C12.4576 25.01 12.4573 25.0103 12.4571 25.0105C12.457 25.0107 12.4568 25.0108 12.8263 25.3477Z"
              fill="" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.basket-delete-overlay {
  @apply fixed top-0 left-0 w-full h-screen flex content-center items-center z-40 opacity-90;
  background-color: rgba(0, 0, 0, 0.5);
}

.basket-delete {
  @apply p-3 fixed z-50 min-w-72 bg-red-eronor top-32 flex items-center flex-col rounded-lg;
}

.basket-overlay {
  @apply fixed top-0 left-0 w-full h-screen flex content-center items-center z-20 opacity-90;

  background-color: rgba(0, 0, 0, 0.5);
}

.svg-validate {
  @apply w-7;
}

.button-validate:hover .svg-validate {
  @apply fill-white-eronor;
}

.div-button-delete {
  @apply flex w-64 justify-between pt-4 px-2;
}

.div-button-delete button {
  @apply p-2 rounded-lg;
}

.svg-cross {
  @apply w-7 p-1 fill-black;
}

.button-delete:hover .svg-cross {
  @apply fill-white-eronor;
}
</style>
